var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dyo",class:{dark: _vm.dark}},[_c('canvas',{attrs:{"id":"canvas"}}),_c('div',{attrs:{"id":"c"}},[_c('input',{attrs:{"id":"file","type":"file","accept":"image/*, .heic, .heif, .HEIC, .HEIF"},on:{"change":_vm.uploadFile}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }